module.exports = __webpack_public_path__ + "img/cali.39297c4a.png";